<template>
  <div class="flex flex-row">
    <div
      class="rounded-full h-12 w-12 cursor-pointer shadow py-2 my-auto mx-auto bg-white"
      @click="scrollLeft"
    >
      <svg-icon
        icon="heroicons/outline/chevron-left"
        class="w-8 h-8 text-gray-400 mx-auto bg-white"
      />
    </div>

    <div
      class="flex-none flex flex-row overflow-x-scroll py-4 px-4"
      style="max-width:80%"
      ref="scroller"
      id="scroller"
    >
      <div
        class="flex-none w-80 cursor-pointer mr-8 my-auto p-4"
      >
        <img
          @click="showModal = 0"
          src="https://s3.amazonaws.com/images.appflowz.com/hotjar_cover.png"
          class="rounded-lg shadow-md hover:shadow-lg border border-solid border-gray-200"
        />

        <TemplateModal
          :showModal="showModal == 0"
          v-on:close="showModal = null"
          :template="templateList[0]"
          text="Our replica of the actual post-signup flow that Hotjar uses to
                    personalize and customize their onboarding experience for
                    new users."
          :path="'/demo/845f8b5f-758a-4d18-a20c-8d9a1dc69018/start'"
          img="https://s3.amazonaws.com/images.appflowz.com/hotjar_cover.png"
        >
        </TemplateModal>
      </div>

      <div
        class="flex-none w-80 cursor-pointer mr-8 my-auto p-4"
      >
        <img
          @click="showModal = 1"
          src="https://s3.amazonaws.com/images.appflowz.com/basecamp_cover.png"
          class="rounded-lg shadow-md hover:shadow-lg border border-solid border-gray-200"
        />

        <TemplateModal
          :showModal="showModal == 1"
          v-on:close="showModal = null"
          :template="templateList[1]"
          text="Our replica of the actual post-signup flow that Hotjar uses to
                    personalize and customize their onboarding experience for
                    new users."
          :path="'/demo/845f8b5f-758a-4d18-a20c-8d9a1dc69018/start'"
          img="https://s3.amazonaws.com/images.appflowz.com/basecamp_cover.png"
        >
        </TemplateModal>
      </div>

      <div
        class="flex-none w-80 cursor-pointer mr-8 my-auto p-4"
      >
        <img
          @click="showModal = 2"
          src="https://s3.amazonaws.com/images.appflowz.com/webflow_narrow.png"
          class="rounded-lg shadow-md hover:shadow-lg border border-solid border-gray-200"
        />

        <TemplateModal
          :showModal="showModal == 2"
          v-on:close="showModal = null"
          :template="templateList[2]"
          text="Webflow uses the following survey flow to tailor their new user onboarding to the specific user projects."
          :path="'/demo/845f8b5f-758a-4d18-a20c-8d9a1dc69018/start'"
          img="https://s3.amazonaws.com/images.appflowz.com/webflow_narrow.png"
        >
        </TemplateModal>
      </div>

      <div
        class="flex-none w-80 cursor-pointer mr-8 my-auto p-4"
      >
        <img
          @click="showModal = 3"
          src="https://s3.amazonaws.com/images.appflowz.com/autopilot_narrow.png"
          class="rounded-lg shadow-md hover:shadow-lg border border-solid border-gray-200"
        />

        <TemplateModal
          :showModal="showModal == 3"
          v-on:close="showModal = null"
          :template="templateList[3]"
          text="Autopilot uses the following survey flow to tailor their new user onboarding to the specific user projects."
          :path="'/demo/845f8b5f-758a-4d18-a20c-8d9a1dc69018/start'"
          img="https://s3.amazonaws.com/images.appflowz.com/autopilot_narrow.png"
        >
        </TemplateModal>
      </div>

      <div
        class="flex-none w-80 cursor-pointer mr-8 my-auto p-4"
      >
        <img
          @click="showModal = 4"
          src="https://s3.amazonaws.com/images.appflowz.com/clickup_cover.png"
          class="rounded-lg shadow-md hover:shadow-lg border border-solid border-gray-200"
        />

        <TemplateModal
          :showModal="showModal == 4"
          v-on:close="showModal = null"
          :template="templateList[4]"
          text="ClickUp uses the following survey flow to tailor their new user onboarding to the specific user projects."
          :path="'/demo/845f8b5f-758a-4d18-a20c-8d9a1dc69018/start'"
          img="https://s3.amazonaws.com/images.appflowz.com/clickup_cover.png"
        >
        </TemplateModal>
      </div>

      <div
        class="flex-none w-80 cursor-pointer mr-8 my-auto p-4"
      >
        <img
          @click="showModal = 5"
          src="https://s3.amazonaws.com/images.appflowz.com/codecademy_narrow.png"
          class="rounded-lg shadow-md hover:shadow-lg border border-solid border-gray-200"
        />

        <TemplateModal
          :showModal="showModal == 5"
          v-on:close="showModal = null"
          :template="templateList[5]"
          text="Codecademy uses the following survey flow to tailor their new user onboarding to the specific user projects."
          :path="'/demo/845f8b5f-758a-4d18-a20c-8d9a1dc69018/start'"
          img="https://s3.amazonaws.com/images.appflowz.com/codecademy_narrow.png"
        >
        </TemplateModal>
      </div>


        <div
        class="flex-none w-80 cursor-pointer mr-8 my-auto p-4"
      >
        <img
          @click="showModal = 6"
          src="https://s3.amazonaws.com/images.appflowz.com/invision_cover.png"
          class="rounded-lg shadow-md hover:shadow-lg border border-solid border-gray-200"
        />

        <TemplateModal
          :showModal="showModal == 6"
          v-on:close="showModal = null"
          :template="templateList[6]"
          text="Invision uses the following survey flow to tailor their new user onboarding to the specific user projects."
          :path="'/demo/845f8b5f-758a-4d18-a20c-8d9a1dc69018/start'"
          img="https://s3.amazonaws.com/images.appflowz.com/invision_cover.png"
        >
        </TemplateModal>
      </div>

    </div>

    <div
      class="bg-white rounded-full h-12 w-12 cursor-pointer shadow p-2 my-auto mx-auto"
      @click="scrollRight"
    >
      <svg-icon
        icon="heroicons/outline/chevron-right"
        class="w-8 h-8 text-gray-400 mx-auto"
      />
    </div>
  </div>
</template>

<script>
//https://ssense.github.io/vue-carousel/
//import { Carousel, Slide } from "vue-carousel";
import { Templates } from "@/mixins/Templates";
//import TemplateModal from "@/components/TemplateModal";
export default {
  mixins: [Templates],
  data() {
    return {
      showModal: null,
    };
  },
  components: {
    TemplateModal: () => import("@/components/TemplateModal"),
  },
  computed: {
    scroll() {
      let scroller = document.getElementById("scroller");
      return scroller.scrollLeft;
    },
  },
  methods: {
    scrollLeft(event) {
      event.preventDefault();
      this.$refs.scroller.scrollLeft -= 80;
    },
    scrollRight(event) {
      event.preventDefault();
      this.$refs.scroller.scrollLeft += 80;
    },
    preventDefault(event){
        if (event.detail > 1) {
          event.preventDefault();
        }
    }
  },
  mounted() {
    document.addEventListener(
      "mousedown", this.preventDefault, false
    );
  },
  destroyed(){

      document.removeEventListener("mousedown", this.preventDefault);

  }
};
</script>

<style></style>
